<span class="model-selection-label">Select the models to be run:</span>
<div class="model-selection-card" [ngClass]="isProjectOwnershipValid? '': 'disabled'" [style.pointer-events]="isProjectOwnershipValid? 'auto': 'none'">
    <div class="model-selection-checkboxes">
        <app-checkbox class="checkboxes-row" [name]="'group'" [options]="options" [binary]="false" [model]="selectedOptions" [disabledOptions]="disabledOptions" (onSelectionChangedEvent)="onModelOptionsChanged($event)"></app-checkbox>
    </div>
</div>
